import { render, staticRenderFns } from "./regionCheckResult.vue?vue&type=template&id=ae476486&scoped=true&"
import script from "./regionCheckResult.vue?vue&type=script&lang=js&"
export * from "./regionCheckResult.vue?vue&type=script&lang=js&"
import style0 from "./regionCheckResult.vue?vue&type=style&index=0&id=ae476486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae476486",
  null
  
)

export default component.exports